import { useContext, useEffect, useState, useCallback } from 'react';
import { SecurityContext } from '../providers/SecurityProvider';

export function useAuth() {
  const { auth } = useContext(SecurityContext);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    const me = await auth.me().catch(() => null);
    setUser(me);
    setLoading(false);
  }, [auth]);

  useEffect(() => { reload(); }, [reload]);

  return {
    user,
    loading,
    login: async (email, password) => {
      const u = await auth.login({ email, password });
      setUser(u);
      return u;
    },
    logout: async () => { await auth.logout(); setUser(null); },
    refresh: () => auth.refresh(),
    reload,
    isAuthenticated: !!user,
    setUser,
    
    forgotPassword: async (data) => { 
      try {
        return await auth.forgotPassword(data); 
      } catch(error) {
        throw error;
      }
    },

    resetPassword: async (data) => { 
      try {
        return await auth.resetPassword(data); 
      } catch(error) {
        throw error;
      }
    },

    activateAccount: async (hash) => { 
      try {
        return await auth.activateAccount(hash); 
      } catch(error) {
        throw error;
      }
    }

  };
}

